module.exports = __webpack_public_path__ + "img/row.babd481d.jpg";